/* Impulse t6214: homepage strip slideshow. Crossfade, dashes, pause, swipe. Without this file the first slide shows and the button works.
   Also fills slide 1 (newest new camera, lens or drone) from the new-gear collection when Liquid could not reach it in its first 50 products. */
(function () {
  'use strict';

  function setup(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.imp-sl__slide'));
    if (slides.length < 2) return;
    var dashes = Array.prototype.slice.call(root.querySelectorAll('.imp-sl__dash'));
    var bars = dashes.map(function (d) { return d.querySelector('.imp-sl__bar i'); });
    var pp = root.querySelector('.imp-sl__pp');
    var count = root.querySelector('.imp-sl__count');
    var hint = root.querySelector('.imp-sl__hint');
    var stage = root.querySelector('.imp-sl__stage');
    var ms = (parseInt(root.getAttribute('data-seconds'), 10) || 6) * 1000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, elapsed = 0, timer = null, paused = reduced, held = false;
    var TICK = 100;

    function paint() {
      slides.forEach(function (s, i) {
        var on = i === cur;
        s.classList.toggle('is-on', on);
        if (on) { s.removeAttribute('inert'); s.removeAttribute('aria-hidden'); }
        else { s.setAttribute('inert', ''); s.setAttribute('aria-hidden', 'true'); }
      });
      dashes.forEach(function (d, i) {
        if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        bars[i].style.width = (i < cur ? 100 : i === cur ? Math.min(100, elapsed / ms * 100) : 0) + '%';
      });
      if (count) count.innerHTML = (cur + 1) + ' of ' + slides.length + (paused ? '<br>paused' : '');
      if (pp) {
        pp.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        /* SVG elements have no .hidden property, so toggle the attribute */
        pp.querySelector('.imp-sl__ico-pause').toggleAttribute('hidden', paused);
        pp.querySelector('.imp-sl__ico-play').toggleAttribute('hidden', !paused);
      }
      stage.setAttribute('aria-live', paused ? 'polite' : 'off');
    }

    function go(n, byUser) {
      cur = (n + slides.length) % slides.length;
      elapsed = 0;
      if (byUser && hint) hint.hidden = true;
      paint();
    }

    function tick() {
      if (paused || held || document.hidden) return;
      elapsed += TICK;
      if (elapsed >= ms) go(cur + 1); else paint();
    }
    function run() { if (!timer && !reduced) timer = setInterval(tick, TICK); }
    function stop() { clearInterval(timer); timer = null; }
    function setPaused(p) { paused = p; paint(); }

    if (pp) pp.addEventListener('click', function () { setPaused(!paused); });
    dashes.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i, true); setPaused(true); });
    });

    /* a mouse over the strip or keyboard focus inside it holds the timer; touch never holds (a tap pauses instead) */
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') held = true; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') held = false; });
    root.addEventListener('focusin', function (e) { held = e.target.matches(':focus-visible'); });
    root.addEventListener('focusout', function () { held = false; });

    /* swipe (40px, mostly sideways) and a tap on the slide to pause */
    var x0 = 0, y0 = 0, down = false, swiped = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; swiped = false; x0 = e.clientX; y0 = e.clientY;
    });
    stage.addEventListener('pointerup', function (e) {
      if (!down) return;
      down = false;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        go(cur + (dx < 0 ? 1 : -1), true);
      } else if (e.pointerType !== 'mouse' && Math.abs(dx) < 10 && Math.abs(dy) < 10 && !e.target.closest('a,button')) {
        setPaused(!paused);
      }
    });
    stage.addEventListener('pointercancel', function () { down = false; });
    stage.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); swiped = false; }
    }, true);

    /* start only once the strip is on screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) run(); else stop(); });
      }, { threshold: 0.2 }).observe(root);
    } else { run(); }

    root.classList.add('imp-sl--js');
    paint();
  }

  /* ---- slide 1: the browser pick ----
     /collections/<handle>/products.json keeps the collection's sort (newest first) and returns up to 250. Same rules as the Liquid fallback:
     a photo, any variant available, no Used tag, title not starting with Used and not an open-box listing. The result is kept in sessionStorage for the visit. */
  var CACHE_KEY = 'imp-sl-new-gear-v2';

  function tagsOf(p) {
    var t = p.tags || [];
    if (typeof t === 'string') t = t.split(',');
    return t.map(function (x) { return String(x).trim().toLowerCase(); });
  }
  function qualifies(p) {
    if (!p.images || !p.images.length) return false;
    if (tagsOf(p).indexOf('used') !== -1) return false;
    if (/^used\b/i.test(p.title) || /open[ -]box/i.test(p.title)) return false;
    return (p.variants || []).some(function (v) { return v.available; });
  }
  function pick(products) {
    for (var i = 0; i < products.length; i++) {
      if (!qualifies(products[i])) continue;
      var p = products[i];
      /* the cheapest variant carries the price and its own compare-at, as in snippets/imp-strip-slide.liquid */
      var low = p.variants[0];
      p.variants.forEach(function (v) { if (parseFloat(v.price) < parseFloat(low.price)) low = v; });
      var price = parseFloat(low.price);
      var was = parseFloat(low.compare_at_price);
      return { handle: p.handle, title: p.title, vendor: p.vendor || '', price: price, was: was > price ? was : 0, image: p.images[0].src, created: p.created_at };
    }
    return null;
  }
  function readCache() {
    try { var c = JSON.parse(sessionStorage.getItem(CACHE_KEY)); return c && 'pick' in c ? c : null; } catch (e) { return null; }
  }
  function writeCache(found) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ pick: found })); } catch (e) { /* private mode: just ask again on the next page */ }
  }
  /* resolves to a pick, null (nothing qualifies) or undefined (could not ask, nothing cached) */
  function resolvePick(handle) {
    var cached = readCache();
    if (cached) return Promise.resolve(cached.pick);
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 5000);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('products.json ' + r.status); return r.json(); })
      .then(function (j) { var found = pick(j.products || []); writeCache(found); return found; })
      .catch(function () { return undefined; })
      .then(function (x) { clearTimeout(timer); return x; });
  }

  function money(n) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n); } catch (e) { return '$' + n.toFixed(2); }
  }
  /* the shop's day (Central), so the kicker matches the Liquid one */
  function isToday(iso) {
    if (!iso) return false;
    try { return iso.slice(0, 10) === new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago' }).format(new Date()); } catch (e) { return false; }
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  /* same parts as snippets/imp-strip-slide.liquid; text goes in as text, never as HTML */
  function buildSlide(p) {
    var url = '/products/' + encodeURIComponent(p.handle);
    var slide = el('div', 'imp-sl__slide is-on');
    slide.setAttribute('data-key', 'just-in');
    slide.setAttribute('data-ground', 'dark');
    slide.setAttribute('role', 'group');
    slide.setAttribute('aria-roledescription', 'slide');
    var copy = el('div', 'imp-sl__copy');
    copy.appendChild(el('span', 'imp-sl__k', 'Just in' + (p.vendor ? ' · ' + p.vendor : '') + (isToday(p.created) ? ' · added today' : '')));
    copy.appendChild(el('h2', 'imp-sl__hook', 'Fresh on the shelf'));
    copy.appendChild(el('p', 'imp-sl__nm', p.title));
    var pr = el('span', 'imp-sl__pr');
    pr.appendChild(el('b', null, money(p.price)));
    if (p.was) {
      pr.appendChild(el('s', null, money(p.was)));
      pr.appendChild(el('span', 'imp-sl__save', 'Save ' + money(p.was - p.price)));
    }
    copy.appendChild(pr);
    var cta = el('a', 'imp-sl__cta', 'See it');
    cta.href = url;
    copy.appendChild(cta);
    var shot = el('a', 'imp-sl__shot');
    shot.href = url;
    shot.tabIndex = -1;
    shot.setAttribute('aria-hidden', 'true');
    var img = el('img');
    var src = new URL(p.image, location.href);
    src.searchParams.set('width', '600');
    img.src = src.href;
    img.alt = '';
    img.width = 200;
    img.height = 200;
    img.loading = 'eager';
    img.setAttribute('fetchpriority', 'high');
    shot.appendChild(img);
    var fig = el('div', 'imp-sl__fig');
    fig.appendChild(shot);
    var pct = p.was ? Math.round((p.was - p.price) * 100 / p.was) : 0;
    if (pct > 0) {
      var badge = el('span', 'imp-sl__badge');
      badge.setAttribute('aria-hidden', 'true');
      badge.appendChild(el('small', null, 'Sale'));
      badge.appendChild(el('strong', null, pct + '%'));
      badge.appendChild(el('em', null, 'off'));
      fig.appendChild(badge);
    }
    slide.appendChild(copy);
    slide.appendChild(fig);
    return slide;
  }

  /* fill or drop the reserved slide 1, then the strip is handed to setup() */
  function settle(root) {
    var pending = root.querySelector('.imp-sl__slide[data-pending]');
    if (!pending) return Promise.resolve();
    root.classList.add('imp-sl--wait');
    return resolvePick(pending.getAttribute('data-collection')).then(function (found) {
      root.classList.remove('imp-sl--wait');
      if (found) { pending.replaceWith(buildSlide(found)); return; }
      /* nothing qualifies (or the list could not be read): slide 1 goes, the other two stay */
      var at = Array.prototype.indexOf.call(root.querySelectorAll('.imp-sl__slide'), pending);
      var dash = root.querySelectorAll('.imp-sl__dashes li')[at];
      pending.remove();
      if (dash) dash.remove();
      var left = root.querySelectorAll('.imp-sl__slide');
      Array.prototype.forEach.call(root.querySelectorAll('.imp-sl__dash'), function (d, i) {
        var lab = d.querySelector('.imp-sl__lab');
        d.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + left.length + ': ' + (lab ? lab.textContent : ''));
      });
      var first = left[0];
      if (first) { first.classList.add('is-on'); first.removeAttribute('inert'); first.removeAttribute('aria-hidden'); first.removeAttribute('data-soft'); }
      if (left.length < 2) {
        var ctl = root.querySelector('.imp-sl__ctl'), hint = root.querySelector('.imp-sl__hint');
        if (ctl) ctl.remove();
        if (hint) hint.remove();
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-imp-sl]'), function (root) {
      settle(root).then(function () { setup(root); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
